import HeroBrand from "@/components/home/HeroBrand";
import GalleryCurated from "@/components/home/GalleryCurated";
import ProcessSteps from "@/components/home/ProcessSteps";
import TrustSignals from "@/components/home/TrustSignals";

const Home = () => {
  return (
    <div>
      <HeroBrand />
      <GalleryCurated />
      <ProcessSteps />
      <TrustSignals />
    </div>
  );
};

export default Home;
